import { METRIC_NAMES } from '@config/Consts';
import { RESOURCES as REPORTING_RESOURCES } from '@core/clients/ReportingClient';
import { RESOURCES as AGENT_MANAGER_RESOURCES } from '@core/clients/AgentManagerClient';
import AgentActivityMetricsModel from '@core/models/AgentActivityMetricsModel';
import AgentViewModel from '@core/models/AgentViewModel';
import AgentManagerMetricsModel from '@core/models/AgentManagerMetricsModel';


const AGENT_LIST_RESOURCES = {
  AGENT_ACTIVITY: REPORTING_RESOURCES.AGENT_ACTIVITY,
  METRICS: AGENT_MANAGER_RESOURCES.METRICS,
  AGENT_VIEW: AGENT_MANAGER_RESOURCES.AGENT_VIEW,
};

const RESOURCES_MODEL_MAP = {
  [REPORTING_RESOURCES.AGENT_ACTIVITY]: AgentActivityMetricsModel,
  [AGENT_MANAGER_RESOURCES.AGENT_VIEW]: AgentViewModel,
  [AGENT_MANAGER_RESOURCES.METRICS]: AgentManagerMetricsModel,
};

const RESOURCES_METRICS_MAP = {
  [REPORTING_RESOURCES.AGENT_ACTIVITY]: [
    METRIC_NAMES.ONLINE_RATE,
  ],
  [AGENT_MANAGER_RESOURCES.AGENT_VIEW]: [
    METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE,
    METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE,
    METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
    METRIC_NAMES.AGENT_VIEW_STATUS_REASON,
    METRIC_NAMES.AGENT_VIEW_AGENT_NAME,
    METRIC_NAMES.AGENT_VIEW_AGENT_GROUP,
    METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS,
    METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
    METRIC_NAMES.AGENT_VIEW_CSAT,
    METRIC_NAMES.AGENT_VIEW_AGENT_LOAD,
    METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION,
    METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION,
    METRIC_NAMES.AGENT_VIEW_CLOSED_CONVERSATIONS,
    METRIC_NAMES.ONLINE_RATE,
    METRIC_NAMES.AGENT_VIEW_ACTIVE_CONVERSATIONS,
    METRIC_NAMES.AGENT_VIEW_MAX_SLOTS,
  ],
  [AGENT_MANAGER_RESOURCES.METRICS]: [
    METRIC_NAMES.AGENT_VIEW_METRICS_ONLINE_AGENTS,
    METRIC_NAMES.AGENT_VIEW_METRICS_AWAY_AGENTS,
    METRIC_NAMES.AGENT_VIEW_METRICS_BACK_SOON_AGENTS,
  ],
};

export {
  AGENT_LIST_RESOURCES,
  RESOURCES_MODEL_MAP,
  RESOURCES_METRICS_MAP,
};
